<script>
import PageHeader from '@/components/layoutComponents/page-header'
import appConfig from '@/app.config'
import MainBoard from '../../components/kanabanBoard'
import { kanbanMixins } from '../../utils/mixins'

export default {
  page: {
    title: 'کنبان بورد',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  mixins: [kanbanMixins],
  data() {
    return {
      items: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'بورد تسک ها',
          active: true,
        },
      ],
    }
  },
  components: {
    PageHeader,
    MainBoard,
  },
}
</script>
<template>
  <div>
    <PageHeader :title="kanbanData.name" :items="items" />
    <MainBoard />
  </div>
</template>
